import { render, staticRenderFns } from "./ConcernKeywords.vue?vue&type=template&id=42d01e88&scoped=true"
import script from "./ConcernKeywords.vue?vue&type=script&lang=js"
export * from "./ConcernKeywords.vue?vue&type=script&lang=js"
import style0 from "./ConcernKeywords.vue?vue&type=style&index=0&id=42d01e88&prod&lang=scss&scoped=true"
import style1 from "./ConcernKeywords.vue?vue&type=style&index=1&id=42d01e88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d01e88",
  null
  
)

export default component.exports